// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"44":"css/app.6647","2238":"css/admin-app.6647"}[chunkId] + ".css";
};